const AllAdditional = [
  {
    id: 30,
    type: "Adicionais",
    name: "Ovo",
    info: null,
    price: "R$1,50"
  }, {
    id: 31,
    type: "Adicionais",
    name: "Batata Palha",
    info: null,
    price: "R$1,50"
  }, {
    id: 32,
    type: "Adicionais",
    name: "Presunto",
    info: null,
    price: "R$2,00"
  }, {
    id: 33,
    type: "Adicionais",
    name: "Milho",
    info: null,
    price: "R$1,50"
  }, {
    id: 34,
    type: "Adicionais",
    name: "Catupiry",
    info: null,
    price: "R$3,00"
  }, {
    id: 35,
    type: "Adicionais",
    name: "Cheddar",
    info: null,
    price: "R$3,00"
  }, {
    id: 36,
    type: "Adicionais",
    name: "Queijo",
    info: null,
    price: "R$3,00"
  }, {
    id: 37,
    type: "Adicionais",
    name: "Bacon",
    info: null,
    price: "R$3,00"
  }, {
    id: 38,
    type: "Adicionais",
    name: "Frango Desfiado",
    info: null,
    price: "R$4,50"
  }, {
    id: 39,
    type: "Adicionais",
    name: "Hamburguer 60g",
    info: null,
    price: "R$4,00"
  }, {
    id: 40,
    type: "Adicionais",
    name: "Hamburguer Picanha 120g",
    info: null,
    price: "R$8,00"
  }, {
    id: 41,
    type: "Adicionais",
    name: "Hambuerguer Picanha 170g",
    info: null,
    price: "R$8,00"
  }, {
    id: 42,
    type: "Adicionais",
    name: "Hamburguer Picanha 200g",
    info: null,
    price: "R$9,00"
  }
]
export default AllAdditional;